/**
 * Échelle unique des couches plein écran.
 * Les z-index locaux (1 à 10, à l’intérieur d’une carte) restent dans le composant.
 *
 * Une modale ouverte après une autre prend la bande suivante :
 * son fond passe au-dessus du contenu et des menus de la modale précédente.
 * Garder les mêmes nombres dans `assets/scss/partials/elpdl/_z-index.scss`.
 */
export const Z_INDEX = {
  shell: 100,
  banner: 1500,
  popover: 5000,
  dropdown: 9000,
  modal: 10000,
  /** Fond, contenu (+1) et menus (+10) tiennent dans cette bande. */
  modalStep: 100,
  toolbox: 12000,
  toast: 12500,
  splash: 22000,
  flow: 26000,
} as const

export const MODAL_LAYER_MAX_DEPTH = 6

export type ModalLayer = {
  depth: number
  scrim: number
  content: number
  popper: number
}

export function modalLayer(depth: number): ModalLayer {
  const bounded = Math.max(0, Math.min(MODAL_LAYER_MAX_DEPTH, depth))
  const scrim = Z_INDEX.modal + bounded * Z_INDEX.modalStep
  return {
    depth: bounded,
    scrim,
    content: scrim + 1,
    popper: scrim + 10,
  }
}
